import styled from 'styled-components'

export const ProgressBarWrapper = styled.div`
  width: 319px;
  height: 3px;
  background-color: #cdf3ff80;
  margin: 30px 0 10px;
`

export const ProgressBarFill = styled.div<{ fillPercentage: number }>`
  width: ${(props) => props.fillPercentage}%;
  height: 100%;
  background-color: #4ad3ff;
  transition: width 0.2s ease-in-out;
`

export const ProgressBarText = styled.p`
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  align-self: center;
`
